import moment from "moment";
import $ from 'jquery';
import { toast } from 'react-custom-alert';
import 'react-custom-alert/dist/index.css'; 

///--------------------------saraserviciosmultiples-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://saraserviciosmultiples.mtechnologypanama.com"; // SERVIDOR 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/saraserviciosmultiples"; // SERVIDOR DE IAMAGENES
///--------------------------saraserviciosmultiples-------------------------------///

///--------------------------maderascocheran-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://maderascocheran.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/maderascocheran"; // SERVIDOR DE IAMAGENES
///--------------------------maderascocheran-------------------------------///
///--------------------------TANIA-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=true;
// export const ENABLE_BOTONES_RESTAURANTE=true;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=true;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="http://192.168.100.25:8080"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="C:/xampp/htdocs/"; // SERVIDOR DE IMAGENES
///--------------------------TANIA-------------------------------///
///--------------------------mtechnologypanama-------------------------------///
// export const VERSION_1 = false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE = true;
// export const ENABLE_BOTONES_RESTAURANTE = true;
// export const RECIBO_NAME = "Cotización";
// export const RECIBO_ENABLED = true;
// export const LOGO_COTIZACION_2_ENABLE = false;
// export const LOGO_COTIZACION_3_ENABLE = false;
// export const IP = "https://mtc.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/mtc"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///
///--------------------------servicios y restaurantes NG-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://serviciosyrestaurantesng.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/serviciosyrestaurantesng"; // SERVIDOR DE IMAGENES
///--------------------------servicios y restaurantes NG-------------------------------///
///--------------------------centrodebaterias-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="RECIBO";
// export const RECIBO_ENABLED=true;
// export const LOGO_COTIZACION_2_ENABLE=true;
// export const LOGO_COTIZACION_3_ENABLE=true;
// export const IP ="https://sistema.centrodebaterias.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/centrodebaterias.com/public_html/sistema"; //NUBE BATERIA
///--------------------------centrodebaterias-------------------------------///

///--------------------------serviciosyrestaurantesng-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://serviciosyrestaurantesng.mtechnologypanama.com"; // SERVIDOR 
// // export const IP_FE_CONSULTAS ="https://serviciosyrestaurantesng.mtechnologypanama.com"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/serviciosyrestaurantesng"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///

///--------------------------fiestasinfantiles-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://fiestasinfantiles.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// // export const IP_FE_CONSULTAS ="https://fiestasinfantiles.mtechnologypanama.com"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/fiestasinfantiles"; // SERVIDOR DE IMAGENES
///--------------------------fiestasinfantiles-------------------------------///
///--------------------------fundacion_los_naturalistas-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://naturalistas.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/naturalistas"; // SERVIDOR DE IMAGENES
///--------------------------fundacion_los_naturalistas-------------------------------///
///--------------------------fundacion_los_naturalistas-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://cdbbgaba.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/cdbbgaba"; // SERVIDOR DE IMAGENES
///--------------------------fundacion_los_naturalistas-------------------------------///
///--------------------------Transmisiones valencia-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://transmisionesvalencia.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/transmisionesvalencia"; // SERVIDOR DE IMAGENES
///--------------------------Transmisiones valencia-------------------------------///
///--------------------------ART_MODUL-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://artmodul.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/artmodul"; // SERVIDOR DE IMAGENES
///--------------------------ART_MODUL-------------------------------///
///--------------------------MARIANA MACHADO-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://marianamachado.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/marianamachado"; // SERVIDOR DE IMAGENES
///--------------------------MARIANA MACHADO-------------------------------///
///--------------------------GRUPPO AZZAM-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://grupoazzamsa.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/grupoazzamsa"; // SERVIDOR DE IMAGENES
///--------------------------GRUPPO AZZAM-------------------------------///
///--------------------------DISTRIBUIDORA ROUXSAC-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://rouxsac.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/rouxsac"; // SERVIDOR DE IMAGENES
///--------------------------DISTRIBUIDORA ROUXSAC-------------------------------///
///--------------------------PASCUAL MORALES MORALES-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://pascualmorales.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/pascualmorales"; // SERVIDOR DE IMAGENES
///--------------------------PASCUAL MORALES MORALES-------------------------------///
///--------------------------TRASPORTE BRAYAN BEITIA-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://trasportebrayanbeitia.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/trasportebrayanbeitia"; // SERVIDOR DE IMAGENES
///--------------------------TRASPORTE BRAYAN BEITIA-------------------------------///
///--------------------------ABTELECOM-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=true;
// export const IP ="https://abtelecom.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/abtelecom"; // SERVIDOR DE IMAGENES
///--------------------------ABTELECOM-------------------------------///
///--------------------------constructorakrcc-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://constructorakrcc.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/constructorakrcc"; // SERVIDOR DE IMAGENES
///--------------------------constructorakrcc-------------------------------///
///--------------------------MULTISERVICIOS GALPAS-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://multiserviciosgalpas.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/multiserviciosgalpas"; // SERVIDOR DE IMAGENES
///--------------------------MULTISERVICIOS GALPAS-------------------------------///
///--------------------------MULTISERVICIOS HALAM-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://multiserviciosyventashalam.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/multiserviciosyventashalam"; // SERVIDOR DE IMAGENES
///--------------------------MULTISERVICIOS HALAM-------------------------------///
///--------------------------PISABEL-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://pisabel.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/pisabel"; // SERVIDOR DE IMAGENES
///--------------------------PISABEL-------------------------------///
///--------------------------EBANISTERIA GONZALEZ JARAMILLO-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://ebanisteriagj.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/ebanisteriagj"; // SERVIDOR DE IMAGENES
///--------------------------MUEBLES & MAS-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://mueblesymas.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/mueblesymas"; // SERVIDOR DE IMAGENES
///--------------------------MUEBLES & MAS-------------------------------///
///--------------------------RT11-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://rt11.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/rt11"; // SERVIDOR DE IMAGENES
///--------------------------RT11-------------------------------///
///--------------------------tecnosuministrosjp-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const ENABLE_BOTONES_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://tecnosuministrosjp.mtechnologypanama.com"; // SERVIDOR 
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
// const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/tecnosuministrosjp"; // SERVIDOR DE IMAGENES
///--------------------------tecnosuministrosjp-------------------------------///
///--------------------------agricoladelatlantico-------------------------------///
export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
export const MODULO_RESTAURANTE=false;
export const ENABLE_BOTONES_RESTAURANTE=false;
export const RECIBO_NAME="Cotización";
export const RECIBO_ENABLED=false;
export const LOGO_COTIZACION_2_ENABLE=false;
export const LOGO_COTIZACION_3_ENABLE=false;
export const IP ="https://agricoladelatlantico.mtechnologypanama.com"; // SERVIDOR 
export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE 
const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/agricoladelatlantico"; // SERVIDOR DE IMAGENES
///--------------------------agricoladelatlantico-------------------------------///
// export const IP ="http://localhost:8080";
// export const IP ="http://192.168.100.25:8080"; // TANIA
// export const IP ="http://192.168.10.105:8080"; //REMATE DE LAS OFERTAS
// export const IP ="http://192.168.50.119:8080"; // BATERIA CHANGUINOLA
// export const IP ="https://sistema.centrodebaterias.com"; // SERVIDOR ONLINE BATERIA


// const IP_IMAGENES ="C:/nginx1.28/html"; //LOCAL
// const IP_IMAGENES ="C:/xampp/htdocs"; //LOCAL
// const IP_IMAGENES ="/home/u565547220/domains/centrodebaterias.com/public_html/sistema"; //NUBE BATERIA

export const url = IP+"/sys_mbo/";
export const urlFacturaElectronica = IP+"/sys_mbo/tax_sysm/";
export const imgURLServer= IP_IMAGENES+"/sys_mbo/uploads/articulos/";
export const imgURLServerGastos= IP_IMAGENES+"/sys_mbo/uploads/gastos/";
export const imgURLServerGastosPreview= IP+"/sys_mbo/uploads/gastos/";
export const imgURLServerPublicidad= IP_IMAGENES+"/sys_mbo/uploads/publicidad/";
export const imgURLLocalImageIp= IP+"/sys_mbo/uploads/publicidad/";
export const imgURLocalImage = IP+"/sys_mbo/uploads/articulos/";


export const nonce="enc-base64";
export const path="login";
export const privateKey="MIICXAIBAAKBgQCqGKukO1De7zhZj6+H0qtjTkVxwTCpvKe4eCZ0FPqri0cb2JZfXJ";

export const data_descuento = [
  { value: '5', label: '5 %'},
  { value: '10', label: '10 %'},
  { value: '15', label: '15 %'},
  { value: '20', label: '20 %'},
  { value: '25', label: '25 %'},
  { value: '30', label: '30 %'},
  { value: '50', label: '50 %'},
]
export const dataTipo = [
  { value: '0', label: 'null',objName:"null" },
  { value: '1', label: 'Administrador',objName:"tipo" },
  { value: '2', label: 'Vendedor',objName:"tipo" },
  { value: '3', label: 'Restaurante tablet',objName:"tipo" },
  { value: '4', label: 'Restaurante factura',objName:"tipo" },
]
export const monthname = [
  {name:"Enero"},
  {name:"Febrero"},
  {name:"Marzo"},
  {name:"Abril"},
  {name:"Mayo"},
  {name:"Junio"},
  {name:"Julio"},
  {name:"Agosto"},
  {name:"Septiembre"},
  {name:"Octubre"},
  {name:"Noviembre"},
  {name:"Diciembre"},
]
export const dataDropdownTipo = [
    { value: '1', label: 'Administrador',objName:"tipo" },
    { value: '2', label: 'Vendedor',objName:"tipo" },
    { value: '3', label: 'Tablet',objName:"restaurante" },
    { value: '4', label: 'Restaurante factura',objName:"restaurante" }
  ]

  export const dataDropdownPrint= [
    { value: '1', label: 'Factura electrónica PDF',objName:"print" },
    { value: '2', label: 'Factura electrónica recibo térmico',objName:"print" },
    // { value: '3', label: 'Comprobante NO fiscal',objName:"print" },
    { value: '4', label: 'Factura electrónica PDF & Recibo térmico',objName:"print" }
  ]

export async function put_compania(data) {
    const response = await fetch(url + "SettingController/put_compania", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function get_report_historial_clientes(cli_id) {
    var urlFetch = url + "ReportsController/get_report_historial_clientes/"+cli_id+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function get_caja_data(caja_n) {
    var urlFetch = url + "SettingController/get_caja_data/"+caja_n+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function get_compania(usr_key_login,compania) {
    var urlFetch = url + "SettingController/get_compania/"+usr_key_login+"/"+compania+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function get_compania_all() {
    var urlFetch = url + "SettingController/get_compania_all/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_bod_bodega(data) {
    const response = await fetch(url + "BodegaController/post_bod_bodega", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_bod_bodega_principal(data) {
    const response = await fetch(url + "BodegaController/put_bod_bodega_principal", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_bod_bodega_sts(data) {
    const response = await fetch(url + "BodegaController/put_bod_bodega_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_bod_bodega(data) {
    const response = await fetch(url + "BodegaController/put_bod_bodega", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function get_bod_bodega() {
    var urlFetch = url + "BodegaController/get_bod_bodega/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function descargar_factura_pdf(data) {
  try {
    const response = await fetch(url + "GastosController/descargar_factura_pdf", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const blob = await response.blob(); // Obtener el archivo como Blob
    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = data+'.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(urlBlob);
  } catch (e) {
    console.error('Error al descargar el archivo PDF:', e);
  }
}
export async function descargar_zip(data) {
  try {
    // Realizar la petición POST para obtener el archivo ZIP
    const response = await fetch(url + "GastosController/descargar_zip", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error en la descarga del archivo ZIP');
    }

    const blob = await response.blob(); // Obtener el archivo como Blob

    // Crear un enlace temporal para la descarga
    const urlBlob = window.URL.createObjectURL(blob);

    // Crear un elemento <a> para simular la descarga
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = 'gastos.zip';  // Nombre del archivo descargado

    // Agregar el <a> al DOM y simular un clic
    document.body.appendChild(a);
    a.click();

    // Eliminar el <a> del DOM
    document.body.removeChild(a);

    // Liberar el objeto URL para evitar fugas de memoria
    window.URL.revokeObjectURL(urlBlob);

  } catch (e) {
    console.error('Error al descargar el archivo ZIP:', e);
  }
}
  export async function descargar_zips(data) {
    const response = await fetch(url + "GastosController/descargar_zip", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function post_cli_cliente(data) {
    const response = await fetch(url + "ClienteController/post_cli_cliente", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export  async function print_report_x(data) {
    $.ajax({
      url: IP_FE_LOCAL+'/sys_mbo/tax_sysm/consultarRucDv.php?action=reporte_x',
      data:JSON.stringify(data),
      type: 'POST',
      success: function(response){
          if(response===1){
          }else{
            console.log(response)
          }
        }
  }); 
    return true;
  }
    export async function  consultar_estadoDocumento({numeroDocumentoFiscal,codigoSucursalEmisor,fac_id,fac_mensaje,fac_resultado,fac_cufe,fac_tipodocumento}) {
     var urlFetch =  urlFacturaElectronica+`consultarRucDv.php?codigoSuc=${encodeURIComponent(codigoSucursalEmisor)}&numeroDocumentoFiscal=${encodeURIComponent(numeroDocumentoFiscal)}&action=EstadoDocumento&date=${encodeURIComponent(moment(new Date()).format("YYYYMMDDHHmmss"))}`
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        const result = JSON.parse(JSON.stringify(data));
        if(result.codigo ==="200"){
        put_fac_factura_sts({fac_id,fac_cufe:result.cufe,fac_resultado:result.resultado,fac_mensaje:result.mensaje,fac_tipodocumento})
        }
      });
    return response;
  }
      export async function  consultar_ruc({ruc}) {
     var urlFetch =  urlFacturaElectronica+`consultarRucDv.php?ruc=${encodeURIComponent(ruc)}&action=GetRucDV&date=${encodeURIComponent(moment(new Date()).format("YYYYMMDDHHmmss"))}`
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return JSON.parse(JSON.stringify(data));
      });
    return response;
  }
  export async function  folios_restantes() {
    var urlFetch = urlFacturaElectronica+ "consultarRucDv.php?&action=foliosRestantes&/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return JSON.parse(JSON.stringify(data));
      });
    return response;
  }
  export async function  open_cashDrawer() {
    var urlFetch = "http://localhost:8080/sys_mbo/tax_sysm/" + "consultarRucDv.php?&action=open_cashDrawer&/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch);
    return response;
  }

  export async function  get_cajas() {
    var urlFetch = url + "SettingController/get_cajas/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function  get_cli_cliente_restaurant() {
    var urlFetch = url + "ClienteController/get_cli_cliente_restaurant/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cli_cliente(usr_sucursal) {
    var urlFetch = url + "ClienteController/get_cli_cliente/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function put_cli_cliente_sts(data) {
    const response = await fetch(url + "ClienteController/put_cli_cliente_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_res_restaurante_sts(data) {
    const response = await fetch(url + "RestauranteController/put_res_restaurante_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_res_restaurante(data) {
    const response = await fetch(url + "RestauranteController/put_res_restaurante", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_cli_cliente(data) {
    const response = await fetch(url + "ClienteController/put_cli_cliente", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_pro_proveedor(data) {
    const response = await fetch(url + "ProveedorController/post_pro_proveedor", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function  get_pro_proveedor() {
    var urlFetch = url + "ProveedorController/get_pro_proveedor/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function put_pro_proveedor_sts(data) {
    const response = await fetch(url + "ProveedorController/put_pro_proveedor_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_pro_proveedor(data) {
    const response = await fetch(url + "ProveedorController/put_pro_proveedor", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_cat_categoria(data) {
    const response = await fetch(url + "CategoriaController/post_cat_categoria", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_cat_categoria() {
    var urlFetch = url + "CategoriaController/get_cat_categoria/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function put_cat_categoria(data) {
    const response = await fetch(url + "CategoriaController/put_cat_categoria", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_cat_categoria_sts(data) {
    const response = await fetch(url + "CategoriaController/put_cat_categoria_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {

        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_des_descuento(data) {
    const response = await fetch(url + "DescuentoController/post_des_descuento", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_gr_garantia(data) {
    const response = await fetch(url + "GarantiaController/post_gr_garantia", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_mar_marca(data) {
    const response = await fetch(url + "MarcaController/post_mar_marca", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_mar_marca() {
    var urlFetch = url + "MarcaController/get_mar_marca/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_des_descuento() {
    var urlFetch = url + "DescuentoController/get_des_descuento/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_gr_garantia() {
    var urlFetch = url + "GarantiaController/get_gr_garantia/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function put_mar_marca(data) {
    const response = await fetch(url + "MarcaController/put_mar_marca", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_des_descuento(data) {
    const response = await fetch(url + "DescuentoController/put_des_descuento", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_des_descuento_sts(data) {
    const response = await fetch(url + "DescuentoController/put_des_descuento_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_gr_garantia(data) {
    const response = await fetch(url + "GarantiaController/put_gr_garantia", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_gr_garantia_sts(data) {
    const response = await fetch(url + "GarantiaController/put_gr_garantia_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_mar_marca_sts(data) {
    const response = await fetch(url + "MarcaController/put_mar_marca_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_res_restaurante(data) {
    const response = await fetch(url + "RestauranteController/post_res_restaurante", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function  get_ord_ordenes(ord_mesa) {
    var urlFetch = url + "OrdenController/get_ord_ordenes/"+ord_mesa+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_ord_ordenes_mesas() {
    var urlFetch = url + "OrdenController/get_ord_ordenes_mesas/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_res_restaurante() {
    var urlFetch = url + "RestauranteController/get_res_restaurante/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_usr_usuario(data) {
    const response = await fetch(url + "UsuarioController/post_usr_usuario", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function  get_ord_cocina() {
    var urlFetch = url + "OrdenController/get_ord_cocina/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_usr_usuario() {
    var urlFetch = url + "UsuarioController/get_usr_usuario/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function put_orden_detalle(data) {
    const response = await fetch(url + "OrdenController/put_orden_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_delete_orden_detalle(data) {
    const response = await fetch(url + "OrdenController/put_delete_orden_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_delete_orden_by_ord(data) {
    const response = await fetch(url + "OrdenController/put_delete_orden_by_ord", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_sts_ordenes(data) {
    const response = await fetch(url + "OrdenController/put_sts_ordenes", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_usr_usuario(data) {
    const response = await fetch(url + "UsuarioController/put_usr_usuario", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_usr_usuario_sts(data) {
    const response = await fetch(url + "UsuarioController/put_usr_usuario_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_art_articulo(data) {
    const response = await fetch(url + "ArticuloController/post_art_articulo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_art_articulo({usr_sucursal}) {
    var urlFetch = url + "ArticuloController/get_art_articulo/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_img_publicidad() {
    var urlFetch = url + "ArticuloController/get_img_publicidad/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_img_publicidad(data) {
    const response = await fetch(url + "ArticuloController/post_img_publicidad", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_img_publicidad(data) {
    const response = await fetch(url + "ArticuloController/put_img_publicidad", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_art_articulo(data) {
    const response = await fetch(url + "ArticuloController/put_art_articulo", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_art_articulo_sts(data) {
    const response = await fetch(url + "ArticuloController/put_art_articulo_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_delete_img(body) {
    const response = await fetch(url + "ArticuloController/put_delete_img", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_delete_img_gastos(body) {
    const response = await fetch(url + "GastosController/put_delete_img", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_delete_img_publicidad(body) {
    const response = await fetch(url + "ArticuloController/put_delete_img_publicidad", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_artb_sts(body) {
    const response = await fetch(url + "ArticuloController/put_artb_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function  get_apartado() {
    var urlFetch = url + "ApartadoController/get_apartado/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_inventario() {
    var urlFetch = url + "CompraController/get_inventario/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function put_cot_cotizacion_sts(data) {
    const response = await fetch(url + "CotizacionController/put_cot_cotizacion_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_dc_compra_sts(data) {
    const response = await fetch(url + "CompraController/put_dc_compra_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_fac_factura_sts({fac_id,fac_cufe,fac_resultado,fac_mensaje,fac_tipodocumento}) {
    var body ={
          fac_id,fac_cufe,fac_resultado,fac_mensaje,fac_tipodocumento
    }
    const response = await fetch(url + "FacturaController/put_fac_factura_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_ap_apartado_sts(data) {
    const response = await fetch(url + "ApartadoController/put_ap_apartado_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function  get_articulo_detail(art_upc) {
    var urlFetch = url + "CompraController/get_articulo_detail/"+art_upc+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_articulo_by_code(art_upc) {
    var urlFetch = url + "CompraController/get_articulo_by_code/"+art_upc+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_dc_compra(data) {
    const response = await fetch(url + "CompraController/post_dc_compra", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function post_ap_apartado(data) {
    const response = await fetch(url + "ApartadoController/post_ap_apartado", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function post_cot_cotizacion(data) {
    const response = await fetch(url + "CotizacionController/post_cot_cotizacion", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function post_artb_bodega(data) {
    const response = await fetch(url + "ArticuloController/post_artb_bodega", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_compra_detalle(dc_identificador) {
    var urlFetch = url + "CompraController/get_compra_detalle/"+dc_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_apartado_detalle(dc_identificador) {
    var urlFetch = url + "ApartadoController/get_apartado_detalle/"+dc_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_all_cotizacion({usr_sucursal}) {
    var urlFetch = url + "CotizacionController/get_all_cotizacion/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cotd_cotizacion_detail(cotd_identificador) {
    var urlFetch = url + "CotizacionController/get_cotd_cotizacion_detail/"+cotd_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function put_dc_compra(data) {
    const response = await fetch(url + "CompraController/put_dc_compra", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function delete_ap_apartado_detalle(data) {
    const response = await fetch(url + "ApartadoController/delete_ap_apartado_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function delete_dc_compra_detalle(data) {
    const response = await fetch(url + "CompraController/delete_dc_compra_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_cotd_cotizacion_detalle_row(data) {
    const response = await fetch(url + "CotizacionController/put_cotd_cotizacion_detail_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_apd_apartado_detalle_row(data) {
    const response = await fetch(url + "ApartadoController/put_apd_apartado_detalle_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_apd_apartado_encabezado(data) {
    const response = await fetch(url + "ApartadoController/put_apd_apartado_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_dcd_compra_detalle_row(data) {
    const response = await fetch(url + "CompraController/put_dcd_compra_detalle_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_ap_apartado_detalle_row(data) {
    const response = await fetch(url + "ApartadoController/post_ap_apartado_detalle_row,", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_dc_compra_detalle_row(data) {
    const response = await fetch(url + "CompraController/post_dc_compra_detalle_row", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_dcd_compra_encabezado(data) {
    const response = await fetch(url + "CompraController/put_dcd_compra_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function processInventario(data) {
    const response = await fetch(url + "CompraController/processInventario", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_fcd_factura_detalle_row(data) {
    const response = await fetch(url + "FacturaController/put_fcd_factura_detalle_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_factura_detalle(fac_identificador) {
    var urlFetch = url + "FacturaController/get_factura_detalle/"+fac_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function put_fac_factura_encabezado(data) {
    const response = await fetch(url + "FacturaController/put_fac_factura_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_factura(fac_id) {
    var urlFetch = url + "FacturaController/get_factura/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_fac_factura_detalle_row(data) {
    const response = await fetch(url + "FacturaController/post_fac_factura_detalle_row", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function delete_fcd_factura_detalle(data) {
    const response = await fetch(url + "FacturaController/delete_fcd_factura_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_ord_orden(data) {
    const response = await fetch(url + "OrdenController/post_ord_orden", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_fac_factura(data) {
    const response = await fetch(url + "FacturaController/post_fac_factura", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_frm_pago() {
    var urlFetch = url + "FormaPagoController/get_frm_pago/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_itbms() {
    var urlFetch = url + "SettingController/get_itbms/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
 
  export  async function post_AnulacionElectronica(data,usr_prints) {   
    const alertError  = ({props}) => toast.error(<><span>{"Código : "+props.codigo}</span><br></br><span>{"Resultado : "+props.resultado}</span><br></br><span>{"Mensaje : "+props.mensaje}</span></>);
    const alertSuccess = ({props}) => toast.success(<><span>{"Código : "+props.codigo}</span><br></br><span>{"Resultado : "+props.resultado}</span><br></br><span>{"Mensaje : "+props.mensaje}</span></>);
    $.ajax({
      url:  data.print_type==="2"?IP_FE_LOCAL+"/sys_mbo/tax_sysm/fac.php":IP+"/sys_mbo/tax_sysm/fac.php",
      crossDomain: true,
      mode: "cors",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': "GET, PUT, POST, DELETE, HEAD, OPTIONS"
      },
      data:JSON.stringify(data),
      type: 'POST',
      success: function(response){
        if(data.print_type !=="3"){
        const posicion = response.indexOf("</style>");
        const result = JSON.parse(response);
        var body_error ={
          result,
          data,
          doc_n:data.fac_docn,
          com_suc:data.dataCompany.com_nombre 
        }
        if(result.codigo ==="200"){
          if(data.print_type==="1"){
            window.open( IP+"/sys_mbo/tax_sysm/pdf/"+data.fac_docn+".pdf?"+moment(new Date()).format("YYYYMMDDHHmmss"));
            setTimeout(() => {
              window.innerWidth <= 620 && descargar_factura_pdf(data.fac_docn)
            }, 1500);
          }
          alertSuccess ({props:result})
          postAnular(data);
        }
        else{
            postError(body_error);
            alertError ({props:result});
        }
        }
        else{
          postAnular(data);
        }
        
      }
  }); 
    return true;
  }

  export async function post_facturaElectronica({ data, formRestaurante, isPost }) {
    const alertError = ({ props }) =>
    toast.error(
      <>
        <span>{"Código : " + props.codigo}</span><br />
        <span>{"Resultado : " + props.resultado}</span><br />
        <span>{"Mensaje : " + props.mensaje}</span>
      </>
    );

    const alertSuccess = ({ props }) =>
    toast.success(
      <>
        <span>{"Código : " + props.codigo}</span><br />
        <span>{"Resultado : " + props.resultado}</span><br />
        <span>{"Mensaje : " + props.mensaje}</span>
      </>
    );

    return new Promise((resolve, reject) => {
    $.ajax({url:`${(data.print_type==="2"||data.print_type==="3")?IP_FE_LOCAL:IP}/sys_mbo/tax_sysm/fac.php`,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(data),
      type: "POST",
      success: function (response) {
        try {
          const result = JSON.parse(response);
          if (data.print_type !== "3") {
            if (result.codigo === "200") {
              if (data.print_type === "1") {
                  window.open(`${IP}/sys_mbo/tax_sysm/pdf/${data.fac_docn}.pdf?`+moment(new Date()).format("YYYYMMDDHHmmss") );
                  setTimeout(() => {
                    window.innerWidth <= 620 && descargar_factura_pdf(data.fac_docn)
                  }, 1500);
                }
              if (isPost) {

                put_fac_factura_sts({ fac_id: data.fac_id,fac_cufe:"0000",fac_resultado:result.resultado,fac_mensaje:result.mensaje,fac_tipodocumento:data.tipoDocumento});
                put_facturado_orden({
                  ordd_identificador: formRestaurante.current_ord_identificador
                });
              }

              alertSuccess({ props: result });
            } else {
              postError({ result, data, doc_n: data.fac_docn,com_suc:data.dataCompany.com_nombre });
              alertError({ props: result });
            }

            setTimeout(() => {
              consultar_estadoDocumento({
                numeroDocumentoFiscal: data.fac_docn,codigoSucursalEmisor:data.codigoSucursalEmisor,fac_id:data.fac_id,fac_cufe:result.cufe,fac_resultado:result.resultado,fac_mensaje:result.mensaje,fac_tipodocumento:data.tipoDocumento});
            }, 5000);
          } else {
            if (isPost) {
              put_fac_factura_sts({ fac_id: data.fac_id,fac_cufe:"0000",fac_resultado:"procesado",fac_mensaje:"El documento se envió correctamente.",fac_tipodocumento:data.tipoDocumento});
              put_facturado_orden({
                ordd_identificador: formRestaurante.current_ord_identificador
              });
            }
          }
          resolve(result.codigo);

        } catch (error) {
          reject(error);
        }
      },
      error: function (err) {
        reject(err);
      }
    });
  });
}


  export async function  get_artb_bodega_by_articulo(artb_articulo) {
    var urlFetch = url + "ArticuloController/get_artb_bodega_by_articulo/"+artb_articulo+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_list_items_restaurante() {
    var urlFetch = url + "ArticuloController/get_list_items_restaurante/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_list_items(usr_sucursal) {
    var urlFetch = url + "ArticuloController/get_list_items/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_list_items_bodega() {
    var urlFetch = url + "ArticuloController/get_list_items_bodega/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_cotizacion() {
    var urlFetch = url + "CotizacionController/get_cotizacion/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function post_cotd_cotizacion_detalle_row(data) {
    const response = await fetch(url + "CotizacionController/post_cotd_cotizacion_detalle_row", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function postAnular(data) {
    const response = await fetch(url + "FacturaController/postAnular", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  
  export async function  get_report_x({startDate,endDate,fac_caja,fac_vendedor}){
    var urlFetch = url + "ReportsController/get_report_x/"+startDate+"/"+endDate+"/"+fac_caja+"/"+fac_vendedor+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_report_ventas_global(fac_fecha) {
    var urlFetch = url + "ReportsController/get_cotizacion/"+fac_fecha+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_list_fac_imprimir({fac_sucursal}) {
    console.log()
    var urlFetch = url + "FacturaController/get_list_fac_imprimir/"+fac_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_list_itemsFactura(fcd_identificador) {
    var urlFetch = url + "ArticuloController/get_list_itemsFactura/"+fcd_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_list_itemsFactura_detail(fcd_identificador) {
    var urlFetch = url + "ArticuloController/get_list_itemsFactura_detail/"+fcd_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_frm_pago_imprimir_fac(fcd_identificador) {
    var urlFetch = url + "FormaPagoController/get_frm_pago_imprimir_fac/"+fcd_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  
  export async function  get_list_anulacion({fac_sucursal}) {
    var urlFetch = url + "FacturaController/get_list_anulacion/"+fac_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function  get_report_existencia_inventario() {
  
    var urlFetch = url + "ReportsController/get_report_existencia_inventario/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_report_x_global(startDate,endDate,suc_sucursal) {
  
    var urlFetch = url + "ReportsController/get_report_x_global/"+startDate+"/"+endDate+"/"+suc_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_report_venta(startDate,endDate,suc_sucursal) {
    var urlFetch = url + "ReportsController/get_report_ventas_global/"+startDate+"/"+endDate+"/"+suc_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  // export  async function print_report_x(data) {
  //   $.ajax({
  //     url: 'http://localhost:8080/sys_mbo/tax_sysm/recibo_reporte_x.php',
  //     data:JSON.stringify(data),
  //     type: 'POST',
  //     success: function(response){
  //         if(response===1){
  //         }else{
  //           console.log(response)
  //         }
  //       }
  // }); 
  //   return true;
  // }

  export async function postError(data) {
    const response = await fetch("https://mtc.mtechnologypanama.com/sys_mbo/ErrorController/postError", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function delete_movimiento_detalle(data) {
    const response = await fetch(url + "MovimientoController/delete_movimiento_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function delete_red_recuento_detalle(data) {
    const response = await fetch(url + "RecuentoController/delete_red_recuento_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_re_recuento_sts(data) {
    const response = await fetch(url + "RecuentoController/put_re_recuento_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

    export async function put_mov_movimiento_sts(data) {
    const response = await fetch(url + "MovimientoController/put_mov_movimiento_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_mov_movimiento_detalle_row(data) {
    const response = await fetch(url + "MovimientoController/put_mov_movimiento_detalle_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function put_red_recuento_detalle_row(data) {
    const response = await fetch(url + "RecuentoController/put_red_recuento_detalle_row", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_mov_movimiento_encabezado(data) {
    const response = await fetch(url + "MovimientoController/put_mov_movimiento_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_re_recuento_encabezado(data) {
    const response = await fetch(url + "RecuentoController/put_re_recuento_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function procesar_movimiento(data) {
  const response = await fetch(url + "MovimientoController/procesar_movimiento", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function procesar_recuento(data) {
  const response = await fetch(url + "RecuentoController/procesar_recuento", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_movd_movimiento_detalle(data) {
  const response = await fetch(url + "MovimientoController/put_movd_movimiento_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_movd_movimiento_detalle(data) {
  const response = await fetch(url + "MovimientoController/post_movd_movimiento_detalle_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_red_recuento_detalle(data) {
  const response = await fetch(url + "RecuentoController/post_red_recuento_detalle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_mov_movimiento(data) {
  const response = await fetch(url + "MovimientoController/post_mov_movimiento", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_re_recuento(data) {
  const response = await fetch(url + "RecuentoController/post_re_recuento", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

  export async function  get_recuento() {
    var urlFetch = url + "RecuentoController/get_recuento/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_movimiento() {
    var urlFetch = url + "MovimientoController/get_movimiento/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_movimiento_detalle(mov_identificador) {
    var urlFetch = url + "MovimientoController/get_movimiento_detalle/"+mov_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_recuento_detalle(re_identificador) {
    var urlFetch = url + "RecuentoController/get_recuento_detalle/"+re_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_trazabilidad() {
    var urlFetch = url + "CompraController/get_trazabilidad/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_trazabilidad_detallado(art_id) {
    var urlFetch = url + "CompraController/get_trazabilidad_detallado/"+art_id+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function  get_ord_ordenes_ord({ordd_identificador}) {
    var urlFetch = url + "OrdenController/get_ord_ordenes_ord/"+ordd_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  export async function  get_ord_ordenes_list({isRestaurant}) {
    var urlFetch = url + "OrdenController/get_ord_ordenes_list/"+isRestaurant+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cot_cotizacion_list({usr_sucursal}) {
    var urlFetch = url + "CotizacionController/get_cot_cotizacion_list/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cot_cotizacion_fac({cot_identificador}) {
    var urlFetch = url + "CotizacionController/get_cot_cotizacion_fac/"+cot_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function put_cot_cotizacion_encabezado(data) {
    const response = await fetch(url + "CotizacionController/put_cot_cotizacion_encabezado", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_entregado_orden(data) {
    const response = await fetch(url + "OrdenController/put_entregado_orden", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function put_ordd_detalle(data) {
    const response = await fetch(url + "OrdenController/put_ordd_detalle", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function post_ordd_detalle(data) {
    const response = await fetch(url + "OrdenController/post_ordd_detalle", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_crp_credito_pago(data) {
    const response = await fetch(url + "CreditoController/post_crp_credito_pago", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function post_cotd_cotizacion_detail_row(data) {
    const response = await fetch(url + "CotizacionController/post_cotd_cotizacion_detail_row", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function delete_cotd_cotizacion_detail(data) {
    const response = await fetch(url + "CotizacionController/delete_cotd_cotizacion_detail", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

  export async function  get_report_ventas_mensuales({startDate,endDate,suc_sucursal}) {
    var urlFetch = url + "ReportsController/get_report_ventas_mensuales/"+startDate+"/"+endDate+"/"+suc_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
    export async function  get_report_productos_vendidos({startDate,endDate}) {
    var urlFetch = url + "ReportsController/get_report_productos_vendidos/"+startDate+"/"+endDate+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_report_productos_masvendidos({startDate,endDate}) {
    var urlFetch = url + "ReportsController/get_report_productos_masvendidos/"+startDate+"/"+endDate+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_report_utilidad_margen({startDate,endDate}) {
    var urlFetch = url + "ReportsController/get_report_utilidad_margen/"+startDate+"/"+endDate+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cr_credito() {
    var urlFetch = url + "CreditoController/get_cr_credito/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

    export async function  get_cr_credito_detalle(crd_cliente) {
    var urlFetch = url + "CreditoController/get_cr_credito_detalle/"+crd_cliente+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_re_retencion() {
    var urlFetch = url + "SettingController/get_re_retencion/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_cr_credito_detalle_byIdentificador(crd_fac_identificador) {
    var urlFetch = url + "CreditoController/get_cr_credito_detalle_byIdentificador/"+crd_fac_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_report_creditos({startDate,endDate,suc_sucursal}) {
    var urlFetch = url + "ReportsController/get_report_creditos/"+startDate+"/"+endDate+"/"+suc_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_crp_credito_pago(crd_fac_identificador) {
    var urlFetch = url + "CreditoController/get_crp_credito_pago/"+crd_fac_identificador+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function put_facturado_orden(data) {
    const response = await fetch(url + "OrdenController/put_facturado_orden", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function delete_crp_credito_pago(data) {
    const response = await fetch(url + "CreditoController/put_crp_credito_pago_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export  async function print_recibo_pago(data) {
    $.ajax({
      url:  'http://localhost:8080/sys_mbo/tax_sysm/recibo_pago_credito.php',
      data:JSON.stringify(data),
      type: 'POST',
      success: function(response){
          if(response===1){
          }else{
            console.log(response)
          }
        }
  }); 
    return true;
  }

  export  async function print_recibo_pagoCopia(data) {
    $.ajax({
      url:  'http://localhost:8080/sys_mbo/tax_sysm/recibo_pago_creditoCopia.php',
      data:JSON.stringify(data),
      type: 'POST',
      success: function(response){
          if(response===1){
          }else{
            console.log(response)
          }
        }
  }); 
    return true;
  }

    export async function post_gas_gastos(data) {
    const response = await fetch(url + "GastosController/post_gas_gastos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  export async function  get_gas_gastos_range({date1,date2,usr_sucursal}) {
    var urlFetch = url + "GastosController/get_gas_gastos_range/"+date1+"/"+date2+"/"+usr_sucursal+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

  export async function  get_gas_gastos({date}) {
    var urlFetch = url + "GastosController/get_gas_gastos/"+date+"/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

    export async function put_gas_gastos(data) {
    const response = await fetch(url + "GastosController/put_gas_gastos", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_gas_gastos_sts(data) {
    const response = await fetch(url + "GastosController/put_gas_gastos_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }


  export async function  get_tipo_gastos() {
    var urlFetch = url + "GastosController/get_tipo_gastos/"+moment(new Date()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

    export async function put_tipo_gastos_sts(data) {
    const response = await fetch(url + "GastosController/put_tipo_gastos_sts", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }
  
  export async function put_tipo_gastos(data) {
    const response = await fetch(url + "GastosController/put_tipo_gastos", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }

      export async function post_tipo_gastos(data) {
    const response = await fetch(url + "GastosController/post_tipo_gastos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(function (e) {
        console.log(e);
      });
    return response;
  }